/** User-facing product name (hosting paths may still say prime-assistant). */
export const PRODUCT_NAME = "Mortgage Broker Assistant";

export const PRODUCT_TAGLINE = "Automated assistants, Velocity tools, and chat for mortgage brokers.";

/** Parent brand — Mortgage Broker Assistant is a BrandMatchGrowth property. */
export const PARENT_BRAND_NAME = "BrandMatchGrowth";
export const PARENT_BRAND_URL = "https://www.brandmatchgrowth.com/";
export const PARENT_BRAND_LOGO_SRC = "/brandmatchgrowth-logo.svg";
